import React from "react";
import {BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from './components/Navbar';
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Careers from "./pages/Career";
import Contact from "./pages/Contact";
import ApplyNow from "./pages/ApplyNow";
import QuotePage from "./pages/QuotePage";

function App() {
  return (
    <Router>
      <Navbar />
     <div style={{ minHeight: "80vh" }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about-us" element={<About />} />
          <Route path="/apply" element={<ApplyNow />} />
          <Route path="/quote" element={<QuotePage />} />
        </Routes>
      </div>
      <Footer />
    </Router>
  );
}

export default App;
